/**
 * Content-rights confirmation shown just above the confirm button on both Add Media
 * summary screens — file upload (`ChooseFileUploadModalSummaryConfirm`) and URL import
 * (`ChooseMediaModalSummaryConfirm`). Kept in one place so the two surfaces can't drift.
 */
export const CONTENT_RIGHTS_NOTICE =
  "By adding media, you confirm you own it or have the rights to it, and that creating clips from it doesn't infringe anyone else's rights. You're responsible for the content you bring to StarZero.";
